/** Notify Collections / AssertionManager after agent actions that create or mutate assertions. */

export const AGENT_ASSERTIONS_CHANGED_EVENT = 'agent-assertions-changed';

export type AgentAssertionsChangedDetail = {
  projectId?: number;
  collectionId?: number;
  requestId?: number;
  source?: string;
  action?: string;
};

function parseOptionalId(value: unknown): number | undefined {
  if (typeof value === 'number' && !Number.isNaN(value) && value > 0) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isNaN(parsed) || parsed <= 0 ? undefined : parsed;
  }
  return undefined;
}

export function dispatchAgentAssertionsChanged(detail: AgentAssertionsChangedDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AGENT_ASSERTIONS_CHANGED_EVENT, { detail }));
}

const ASSERTION_MUTATING_AGENT_ACTIONS = new Set([
  'suggest_datasets',
  'suggest_assertions',
]);

export function notifyAgentAssertionsChangedFromAgent(
  action: string | undefined,
  payload?: Record<string, unknown> | null,
  session?: { projectId?: number | null } | null,
): void {
  if (!action || !ASSERTION_MUTATING_AGENT_ACTIONS.has(action)) return;
  dispatchAgentAssertionsChanged({
    projectId: parseOptionalId(payload?.projectId) ?? parseOptionalId(session?.projectId),
    collectionId: parseOptionalId(payload?.collectionId),
    requestId: parseOptionalId(payload?.requestId),
    source: 'agent',
    action,
  });
}
